"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckDemandPartnerTypePipe = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
let CheckDemandPartnerTypePipe = class CheckDemandPartnerTypePipe {
    transform(value, key, val) {
        if (value) {
            if (key && val)
                return value.filter(item => JSON.stringify(item[key].type) == val);
            else
                return value;
        }
    }
};
exports.CheckDemandPartnerTypePipe = CheckDemandPartnerTypePipe;
exports.CheckDemandPartnerTypePipe = CheckDemandPartnerTypePipe = __decorate([
    (0, core_1.Pipe)({ name: 'checkDPType', pure: false })
], CheckDemandPartnerTypePipe);
//# sourceMappingURL=check-demand-partner-type.pipe.js.map